

import axios from "axios";
import { notifySessionExpired } from "../utils/sessionBus";
const apiBaseURL = "https://dev-api.curu.com.au/api";

const api = axios.create({
  baseURL: apiBaseURL,
});


api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


api.interceptors.response.use(
  (response) => response,
  async (error) => {
   
    let originalRequest = error.config;
    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (
      error?.response?.status === 401 &&
      (!originalRequest || !originalRequest._retry)
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token.");
        }
        const response = await axios.post(apiBaseURL + "/auth/token/refresh/", {
          refresh: refreshToken,
        });
        const { access, refresh } = response.data;

        localStorage.setItem("token", access);
        localStorage.setItem("refreshToken", refresh);

        // Retry the original request with the new token
        axios.defaults.headers.common["Authorization"] = `Bearer ${access}`;
        return api(originalRequest);
      } catch (error) {
        // Refresh failed: Unified pop-up window
        console.log(error);
        notifySessionExpired();
      }
    }

    return Promise.reject(error);
  }
);

export const getCache = (key) => {
  const currentTime = new Date().getTime();
  let item = JSON.parse(window.localStorage.getItem(key));
  if (!item || item.expiration <= currentTime) {
    window.localStorage.removeItem(key);
    return null;
  }
  return item.data;
};

export const setCache = (
  key,
  value,
  expiration = new Date().getTime() + 86400000 * 7
) => {
  window.localStorage.setItem(
    key,
    JSON.stringify({
      data: value,
      expiration: expiration,
    })
  );
};

export default api;
